import {Helmet} from "react-helmet";
import {RouteHelper} from "../../route/RouteHelper";
import {
    RaikoBaseCardContainer,
    RaikoBaseContainer, RaikoBreadcrumb,
    raikoBreadCrumbItemGenerator, RaikoCustomSimpleActiveDeActiveChip, RaikoCustomTable,
    RaikoGridOneColumn, RaikoTableTitleContainer, showServerErrorMessage
} from "@moeindal/base-raiko-panel-components";
import React, {useEffect, useState} from "react";
import {css} from "@emotion/css";
import {MawakibService} from "../../serverService/mawakibService/MawakibService";
import {useNavigate} from "react-router-dom";

export default function MawakibRegistrationLocation() {

    let page = 0
    const size = 15

    const [numberOfItems, setNumberOfItems] = useState(0);
    const [mawkibLocationData, setMawkibLocationData] = useState([]);
    const [tableLoading, setTableLoading] = useState(false);
    const [pageCount, setPageCount] = useState(0)

    const service = new MawakibService()

    const navigate = useNavigate()

    useEffect(() => {
        if (typeof service !== 'undefined') {
            getMawakibLocationFromServer()
        }
    }, []);


    function getMawakibLocationFromServer() {
        setTableLoading(true)

        service.getMawkibRegistrationLocation(page, size)
            .then(response => {
                setPageCount(response.totalPage)
                setNumberOfItems(response.numberOfItems)
                setMawkibLocationData([])
                response.data.map((item, index) => {
                    setMawkibLocationData(prevState => [
                        ...prevState,
                        createMawakibLocationTableRow(
                            item.id,
                            (page * size) + index + 1,
                            item.title,
                            item.groupLink,
                            item.enabled
                        )
                    ])
                })
            }).catch(reason => {
            showServerErrorMessage(reason)
        }).finally(_ => {
            setTableLoading(false)
        })

    }

    function handlePageChanging(newPage) {
        page = newPage
        getMawakibLocationFromServer()
    }

    function showMawakibLocationDetails(mawkibLocationId) {

        let _title = ""
        mawkibLocationData.map((item) => {
            if (item.id === mawkibLocationId) {
                _title = item.title
            }
        })
        navigate(RouteHelper.MawakibLocationDetails.globalUrl.replace(":id", mawkibLocationId),
            {state: {title: _title}, replace: false}
        )

    }

    return (
        <>
            <Helmet><title>{RouteHelper.MawakibRegistrationLocation.name}</title></Helmet>
            <RaikoBaseContainer>
                <RaikoGridOneColumn className={css`gap: 1.5rem`}>
                    <RaikoBreadcrumb
                        breadCrumbItems={[
                            raikoBreadCrumbItemGenerator(
                                RouteHelper.MawakibManager.name,
                                ""
                            ),
                            raikoBreadCrumbItemGenerator(
                                RouteHelper.MawakibRegistrationLocation.name,
                                ""
                            ),
                        ]}/>
                    <RaikoBaseCardContainer>
                        <RaikoGridOneColumn>
                            <RaikoTableTitleContainer
                                title={RouteHelper.MawakibRegistrationLocation.name}
                                amount={numberOfItems}
                            />
                            <RaikoCustomTable
                                header={mawakibLocationTableHeader}
                                data={mawkibLocationData}
                                pageCount={pageCount}
                                isLoading={tableLoading}
                                handlePaginationChange={handlePageChanging}
                                rowClicked={showMawakibLocationDetails}
                            />
                        </RaikoGridOneColumn>
                    </RaikoBaseCardContainer>
                </RaikoGridOneColumn>
            </RaikoBaseContainer>

        </>
    )
}

function createMawakibLocationTableRow(id, number, title, groupLink, enabled) {
    return {
        id,
        number,
        title,
        groupLink,
        enabled: <RaikoCustomSimpleActiveDeActiveChip state={enabled} activeStateTitle={"فعال"}
                                                      deActiveStateTitle={"غبر فعال"}/>
    }

}

const mawakibLocationTableHeader = [
    {
        id: "number",
        label: "#",
    },
    {
        id: "title",
        label: "عنوان",
    },
    {
        id: "groupLink",
        label: "لینک گروه",
    },
    {
        id: "enabled",
        label: "وضعیت",
    },

]